import React from 'react';
import { Link } from 'react-router-dom';
import {
  FiHome,
  FiUsers,
  FiUserCheck,
  FiCalendar,
  FiFileText,
  FiPackage,
  FiBarChart2,
  FiSettings,
  FiUserPlus,
  FiX
} from 'react-icons/fi';
import styles from './Sidebar.module.css';
import { useAuth } from '../contexts/AuthContext';

const Sidebar = ({ isOpen, onClose, currentPath }) => {
  const { hasPermission, isAdmin, permissions, user, loading } = useAuth();
  
  console.log('🔍 DEBUG SIDEBAR - Auth state:', { user, permissions, loading });

  const menuItems = [
    // Grupo Financeiro
    {
      path: '/financeiro/contas-receber',
      label: 'Contas a Receber',
      icon: FiBarChart2,
      requiresPermission: 'relatorios:view_financeiro'
    },
    {
      path: '/financeiro/contas-pagar',
      label: 'Contas a Pagar',
      icon: FiBarChart2,
      requiresPermission: 'relatorios:view_financeiro'
    },
    {
      path: '/financeiro/relatorios',
      label: 'Relatórios Financeiros',
      icon: FiBarChart2,
      requiresPermission: 'relatorios:view_financeiro'
    },
    {
      path: '/dashboard',
      label: 'Dashboard',
      icon: FiHome,
      requiresPermission: null // Dashboard acessível a todos os usuários autenticados
    },
    {
      path: '/agendamentos',
      label: 'Agendamentos',
      icon: FiCalendar,
      requiresPermission: 'cadastros:create_consultas'
    },
    {
      path: '/pacientes',
      label: 'Pacientes',
      icon: FiUsers,
      requiresPermission: 'cadastros:create_pacientes'
    },
    {
      path: '/medicos',
      label: 'Médicos',
      icon: FiUserCheck,
      requiresPermission: 'cadastros:create_medicos'
    },
    {
      path: '/consultas',
      label: 'Consultas',
      icon: FiCalendar,
      requiresPermission: 'cadastros:create_consultas'
    },
    {
      path: '/exames',
      label: 'Exames',
      icon: FiFileText,
      requiresPermission: 'cadastros:create_exames'
    },
    {
      path: '/farmacia',
      label: 'Farmácia',
      icon: FiPackage,
      requiresPermission: 'cadastros:create_vendas'
    },
    {
      path: '/medicamentos',
      label: 'Medicamentos',
      icon: FiPackage,
      requiresPermission: 'cadastros:create_medicamentos'
    },
    {
      path: '/fornecedores',
      label: 'Fornecedores',
      icon: FiUsers,
      requiresPermission: null // Acessível a todos autenticados, ajuste se necessário
    },
    {
      path: '/relatorios',
      label: 'Relatórios',
      icon: FiBarChart2,
      requiresPermission: 'relatorios:view_financeiro'
    },
    {
      path: '/configuracoes',
      label: 'Configurações',
      icon: FiSettings,
      requiresPermission: 'configuracoes:view_financeiras'
    },
    {
      path: '/gerenciar-usuarios',
      label: 'Gerenciar Usuários',
      icon: FiUserPlus,
      adminOnly: true
    }
  ];

  // Função para verificar se tem alguma permissão do módulo
  const hasAnyModulePermission = (modulePermission) => {
    // Se não requer permissão (null ou undefined), permitir acesso
    if (!modulePermission) {
      return true;
    }
    
    const [module] = modulePermission.split(':');
    
    // Verificar se tem a permissão específica
    if (hasPermission(modulePermission)) {
      return true;
    }
    
    // Verificar se tem alguma permissão do módulo
    if (permissions && permissions[module]) {
      const modulePerms = permissions[module];
      return Object.values(modulePerms).some(scope => scope !== 'none');
    }
    
    return false;
  };

  // Filtrar itens do menu baseado nas permissões
  const visibleMenuItems = menuItems.filter(item => {
    if (item.adminOnly) {
      return isAdmin();
    }
    return hasAnyModulePermission(item.requiresPermission);
  });

  // Se ainda está carregando, mostrar loading
  if (loading) {
    return (
      <aside className={`${styles.sidebar} ${isOpen ? styles.open : ''}`}>
        <div className={styles.sidebarHeader}>
          <h2 className={styles.sidebarTitle}>Carregando...</h2>
        </div>
      </aside>
    );
  }

  return (
    <>
      <aside className={`${styles.sidebar} ${isOpen ? styles.open : ''}`}>
        <div className={styles.sidebarHeader}>
          <h2 className={styles.sidebarTitle}>Menu</h2>
          <button
            onClick={onClose}
            className={styles.closeButton}
            aria-label="Fechar menu"
          >
            <FiX />
          </button>
        </div>

        <nav className={styles.sidebarNav}>
          <ul className={styles.menuList}>
            {visibleMenuItems.map((item) => {
              const Icon = item.icon;
              const isActive = currentPath === item.path;
              
              return (
                <li key={item.path} className={styles.menuItem}>
                  <Link
                    to={item.path}
                    className={`${styles.menuLink} ${isActive ? styles.active : ''}`}
                    onClick={onClose}
                  >
                    <Icon className={styles.menuIcon} />
                    <span className={styles.menuLabel}>{item.label}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

        <div className={styles.sidebarFooter}>
          <div className={styles.footerInfo}>
            <p className={styles.footerText}>Lumi One Clínica</p>
            <p className={styles.footerVersion}>v1.0.0</p>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;